import {Field, Form, Formik} from "formik";
import GooglePlace from "../googlePlace/googlePlace";
import {DeliveryBillingAddress} from "../../interfaces/cart-interfaces";
import Loader from "../loader/loader";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {format} from "date-fns";
import * as yup from "yup";
import {useTranslation} from "next-i18next";
import Head from "next/head";
import styles from "./customer-form.module.scss";
import PhoneInput from "react-phone-input-2";
import {config} from "../../config-merchant";
import 'react-phone-input-2/lib/style.css'
import 'react-toastify/dist/ReactToastify.css';
import {AxiosResponse} from "axios";
import {loginCustomer} from "../../store/action";
import {useDispatch} from "react-redux";

declare const google: any

export default function CustomerForm(props: {
    onSubmit: (values: {}) => Promise<AxiosResponse>,
    initialValues: {},
    onRedirect: () => void,
    isUpdate: boolean
}) {

    const {t} = useTranslation('common');
    const dispatch = useDispatch();

    const [isSubmitClicked, setSubmitClicked] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isGMapLoading, setGMapLoading] = useState<boolean>(typeof google === 'undefined')
    const [schema, setSchema] = useState<object>({})

    // @ts-ignore
    typeof window !== 'undefined' ? window.gMapLoadedComplete = () => {
        setGMapLoading(false);
    } : null

    const options = {
        autoClose: 3000,
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
    };
    const dateJ = format(new Date(), 'dd-MM-yyyy-H:mm');


    const handleSubmit = async (values) => {
        setLoading(true);

        //TODO customFields
        const formattedValues = {
            defaultDeliveryAddress: {
                ...values.deliveryAddress,
                name: values.name,
                companyName: values.companyName,
                complement: values.addressCompl
            },
            defaultBillingAddress: {
                ...values.billingAddress,
                name: values.billingName,
                companyName: values.billingCompanyName
            },
            email: values.email,
            password: values.password,
            phone: values.phoneNumber
        }

        if (values.sameAddress) {
            formattedValues.defaultBillingAddress = formattedValues.defaultDeliveryAddress;
        }
        props.onSubmit(formattedValues)
            .then(response => {
                setLoading(false);
                dispatch(loginCustomer(response.data));
                props.onRedirect();
            })
            .catch(err => {
                setLoading(false);
                if (err.response.status === 403) {
                    toast(t('SIGNUP_PAGE_ERROR_EMAIL_EXISTS'), options);
                } else {
                    toast(t('TOAST_UNEXPECTED_ERROR'), options);
                }
            })
    }

    const setDeliveryFieldsValues = (setFieldValue: any, addressObject: { address: DeliveryBillingAddress, addressOneLine: string }) => {
        setFieldValue("deliveryAddressOneLine", addressObject.addressOneLine);
        setFieldValue("deliveryAddress", addressObject.address);
    }
    const setBillingFieldsValues = (setFieldValue: any, addressObject: { address: DeliveryBillingAddress, addressOneLine: string }) => {
        setFieldValue("billingAddressOneLine", addressObject.addressOneLine);
        setFieldValue("billingAddress", addressObject.address);
    }

    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    useEffect(() => {
        let tmpSchema = {
            name: yup.string().min(2, t('ORDER_ERROR_NAME')).required(t('ORDER_MISSING_NAME')),
            email: yup.string().required(t('ORDER_MISSING_MAIL')).email(t('ORDER_ERROR_MAIL')),
            companyName: yup.string().nullable(),
            deliveryAddress: yup.mixed(),
            deliveryAddressOneLine: yup.string().required(t('ORDER_MISSING_ADDRESS')),
            addressCompl: yup.string().nullable(),
            phoneNumber: yup.string().required(t('ORDER_MISSING_PHONE')).matches(phoneRegExp, t('ORDER_ERROR_PHONE')),
            sameAddress: yup.bool(),
            billingAddress: yup.mixed(),
            billingAddressOneLine: yup.string().nullable().when("sameAddress", {
                is: false,
                then: yup.string().required(t('ORDER_MISSING_ADDRESS_2'))
            }),
            billingName: yup.string().nullable().when("sameAddress", {
                is: false,
                then: yup.string().min(2, t('ORDER_ERROR_NAME')).required(t('ORDER_MISSING_NAME')),
            }),
            billingCompanyName: yup.string().nullable(),
            password: yup.string().required(t("SIGNUP_PAGE_PASSWORD_REQUIRED"))
                .min(8, t("SIGNUP_PAGE_PASSWORD_SIZE_ERROR"))
                .max(30, t("SIGNUP_PAGE_PASSWORD_SIZE_ERROR"))
                .matches(/[a-z]/, t("SIGNUP_PAGE_PASSWORD_LOWER_ERROR"))
                .matches(/[A-Z]/, t("SIGNUP_PAGE_PASSWORD_UPPER_ERROR"))
                .matches(/[0-9]/, t("SIGNUP_PAGE_PASSWORD_NUMBER_ERROR")),
        };
        if (props.isUpdate) {
            tmpSchema.password = yup.string()
                .min(8, t("SIGNUP_PAGE_PASSWORD_SIZE_ERROR"))
                .max(30, t("SIGNUP_PAGE_PASSWORD_SIZE_ERROR"))
                .matches(/[a-z]/, t("SIGNUP_PAGE_PASSWORD_LOWER_ERROR"))
                .matches(/[A-Z]/, t("SIGNUP_PAGE_PASSWORD_UPPER_ERROR"))
                .matches(/[0-9]/, t("SIGNUP_PAGE_PASSWORD_NUMBER_ERROR"))
        }
        setSchema(yup.object(tmpSchema));
    }, []);

    return (
        <>
            <Head>
                <script
                    src={"https://maps.googleapis.com/maps/api/js?key=AIzaSyD6iA-dNsZnbiKwTjwB_fVDgCTHr74rUJ4&libraries=places&callback=gMapLoadedComplete"}
                />
            </Head>
            <div className={`${styles['signup']}`}>
                <div className={styles["signup-text"]}>
                    <div className={styles["signup-form"]}>
                        <Formik
                            initialValues={props.initialValues}
                            onSubmit={handleSubmit}
                            validationSchema={schema}
                        >
                            {({
                                  errors,
                                  handleChange,
                                  touched,
                                  setFieldValue,
                                  values
                              }) => (
                                <Form>
                                    <h4>{t("SIGNUP_PAGE_PERSONNEL_INFO")}</h4>
                                    {(isSubmitClicked && errors.email) &&
                                        <div className={styles['error-form']}>{errors.email}</div>}
                                    <Field
                                        name="email"
                                        type="email"
                                        onChange={handleChange}
                                        placeholder={t('CONTACT_PH_EMAIL')}
                                        value={values.email}
                                    />
                                    {(isSubmitClicked && errors.phoneNumber) &&
                                        <div className={styles['error-form']}>{errors.phoneNumber}</div>}
                                    <div className={styles['phone-wrapper']}>
                                        <PhoneInput
                                            dropdownClass={styles['phone-dropdown']}
                                            inputClass={styles['phone-input']}
                                            buttonClass={styles['phone-button']}
                                            country={config.enabledDeliveryCountry[0] ? config.enabledDeliveryCountry[0] : 'fr'}
                                            value={values.phoneNumber}
                                            onChange={phone => setFieldValue('phoneNumber', phone)}
                                            disabled={isLoading}
                                        />
                                    </div>
                                    {(isSubmitClicked && errors.password) &&
                                        <div className={styles['error-form']}>{errors.password}</div>}
                                    {props.isUpdate && <div className={styles['password-label']}>
                                        {t("MY_ACCOUNT_UPDATE_PASSWORD")}
                                    </div>}
                                    <Field
                                        name="password"
                                        type="password"
                                        onChange={handleChange}
                                        placeholder={t('SIGNUP_PAGE_PASSWORD_PLACEHOLDER')}
                                        value={values.password}
                                    />

                                    <h4>{t("SIGNUP_PAGE_DELIVERY_ADDRESS")}</h4>
                                    {(isSubmitClicked && errors.name) &&
                                        <div className={styles['error-form']}>{errors.name}</div>}
                                    <Field
                                        name="name"
                                        type="text"
                                        placeholder={t('ORDER_PLACEHOLDER_NAME')}
                                        onChange={handleChange}
                                    />
                                    {config.enabledB2B === true ?
                                        <>
                                            {(isSubmitClicked && errors.companyName) &&
                                                <div className={styles['error-form']}>{errors.companyName}</div>}
                                            <Field
                                                name="companyName"
                                                type="text"
                                                placeholder={t('ORDER_PLACEHOLDER_COMPANY')}
                                                onChange={handleChange}
                                            />
                                        </> : <></>
                                    }
                                    {(isSubmitClicked && errors.deliveryAddressOneLine) &&
                                        <div className={styles['error-form']}>{errors.deliveryAddressOneLine}</div>}
                                    {!isGMapLoading &&
                                        <GooglePlace
                                            addressDefault={values.deliveryAddressOneLine}
                                            dateJ={dateJ}
                                            id={"delivery-address"}
                                            placeholder={t("ORDER_PLACEHOLDER_ADDRESS")}
                                            name={"deliveryAddress"}
                                            onAddressSelected={(addressObject: { address: DeliveryBillingAddress, addressOneLine: string }) => setDeliveryFieldsValues(setFieldValue, addressObject)}
                                            disabled={isLoading}/>}
                                    <Field
                                        name="addressCompl"
                                        type="text"
                                        placeholder={t('ORDER_PLACEHOLDER_ADDRESS_COMPL')}
                                        onChange={handleChange}
                                    />
                                    <label className={styles["checkbox-container"]}>
                                        <span>{t("ORDER_BILLING_SAME")}</span>
                                        <Field type="checkbox" name="sameAddress"/>
                                        <span className={styles["checkmark"]}/>
                                    </label>
                                    {
                                        !values.sameAddress && <div className={styles["billing-block"]}>
                                            <h4>{t("SIGNUP_PAGE_BILLING_ADDRESS")}</h4>
                                            {(isSubmitClicked && errors.billingName) &&
                                                <div className={styles['error-form']}>{errors.billingName}</div>}
                                            <Field
                                                name="billingName"
                                                type="text"
                                                placeholder={t('ORDER_PLACEHOLDER_NAME')}
                                                onChange={handleChange}
                                            />
                                            {config.enabledB2B === true ?
                                                <>
                                                    {(isSubmitClicked && errors.billingCompanyName) &&
                                                        <div
                                                            className={styles['error-form']}>{errors.billingCompanyName}</div>}
                                                    <Field
                                                        name="billingCompanyName"
                                                        type="text"
                                                        placeholder={t('ORDER_PLACEHOLDER_COMPANY')}
                                                        onChange={handleChange}
                                                    />
                                                </> : <></>
                                            }
                                            {(isSubmitClicked && errors.billingAddressOneLine) &&
                                                <div className={styles['error-form']}>{errors.billingAddressOneLine}</div>}
                                            {!isGMapLoading &&
                                                <GooglePlace
                                                    addressDefault={values.billingAddressOneLine}
                                                    dateJ={dateJ}
                                                    id={"billing-address"}
                                                    placeholder={t("ORDER_PLACEHOLDER_ADDRESS")}
                                                    name={"billingAddress"}
                                                    onAddressSelected={(addressObject: { address: DeliveryBillingAddress, addressOneLine: string }) => setBillingFieldsValues(setFieldValue, addressObject)}
                                                    disabled={isLoading}/>}
                                        </div>
                                    }
                                    <div className={styles["loader-place"]}>{isLoading && <Loader/>}</div>
                                    <button
                                        type="submit"
                                        onClick={() => setSubmitClicked(true)}
                                    >
                                        {props.isUpdate ? t("MY_ACCOUNT_UPDATE_SUBMIT") : t('SIGNUP_PAGE_SUBMIT')}
                                    </button>
                                </Form>)}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}
